/* 
   this store is used to manage the admins teams and users. 
        - fetch teams that the admin can update
        - fetch users that the admin can update
        - get the role of the admin
*/
import { getRequest, apiDomainEmploy } from '@/System/Store/endpoints';

const initialState = () => ({
    myTeams: [],
    myColleagues: [],
    activeRole: [],
});

const state = initialState();

const mutations = {
    SET_MY_TEAMS: (state, teams) => (state.myTeams = teams),
    SET_MY_COLLEAGUES: (state, employees) => (state.myColleagues = employees),
    SET_ACTIVE_ROLE: (state, role) => (state.activeRole = role),
    ADD_TEAM_TO_LIST: (state, team) => {
        team = { id: team.id, name: team.name, isWritable: true, department_id: team.department_id };

        state.myTeams = [...state.myTeams, team];
    },
    REMOVE_TEAM_FROM_LIST: (state, teamId) => {
        state.myTeams = state.myTeams.filter((team) => team.id !== teamId);
    },
};
const actions = {
    async FETCH_MY_TEAMS({ commit }, profileId) {
        const response = await getRequest(`${apiDomainEmploy}/employees/${profileId}/teams`);
        if (response.status === 'Success') {
            const { teams, employees } = response.data;

            commit('SET_MY_TEAMS', teams);
            commit('SET_MY_COLLEAGUES', employees);
        }
    },
    async FETCH_MY_ROLE({ commit }, profileId) {
        const response = await getRequest(`${apiDomainEmploy}/employees/${profileId}/role`);
        if (response.status === 'Success') {
            commit('SET_ACTIVE_ROLE', response.data);
        }
    },
};
const getters = {
    GET_ACTIVE_ROLE: (state) => state.activeRole,
    GET_MY_TEAMS: (state) => state.myTeams,
    GET_TEAM_LIST: (state) => state.myTeams,
    GET_COLLEAGUE_LIST: (state) =>
        state.myColleagues?.map((employee) => ({
            id: employee.id,
            name: `${employee?.first_name} ${employee?.last_name}`,
            profile: employee?.profile,
            user_profile_id: employee?.profile?.id,
            user: employee,
            email: employee?.user?.email,
        })),
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
